import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { first, withLatestFrom } from 'rxjs/operators';

import { ChangeCoverageFeatureFacade } from '@amfam/policy/change-coverage/feature';
import { FEATURES } from '@amfam/policy/vehicle-coverages/data-access';
import { userQuery } from '@amfam/shared/user';
import { BrandSelectors } from '@amfam/shared/utility/brand';
import { fromRouterActions } from '@amfam/shared/utility/navigation';
import { CopyService } from '@amfam/shared/utility/shared-services';
import { ConfirmationModel, DockingBarService, PageTitleService } from '@amfam/ui-kit';

@Component({
  selector: 'amfam-coverage-update-confirmation',
  templateUrl: './change-coverage-confirmation.component.html',
  styleUrls: ['./change-coverage-confirmation.component.scss'],
  standalone: false
})
export class ChangeCoverageConfirmationComponent implements OnInit {
  public confirmationData: ConfirmationModel;
  public confirmationHeader: string;
  public confrimationSubheader: string;
  isPartner: boolean;
  private changeCoverageText = this.copyService.getCopy('policy.changeCoverage.pageTitle');
  private changeCoveragePageHeader = this.copyService.getCopy('policy.changeCoverage.pageHeader');
  constructor(
    private copyService: CopyService,
    private store: Store,
    private pageTitle: PageTitleService,
    private dockingBarService: DockingBarService,
    public changeCoverageFeatureFacade: ChangeCoverageFeatureFacade
  ) {}

  ngOnInit(): void {
    this.pageTitle.set(this.changeCoverageText);
    this.dockingBarService.registerHeading(this.changeCoveragePageHeader);
    this.store
      .select(userQuery.selectEmailAddress)
      .pipe(withLatestFrom(this.store.select(BrandSelectors.selectIsPartner)), first())
      .subscribe(([emailAddress, isPartner]) => {
        this.confrimationSubheader = this.copyService.getCopy(
          isPartner
            ? 'policy.changeCoverage.policyConfirmDescription'
            : 'policy.changeCoverage.policyConfirmDescriptionAFI',
          {
            customeremail: emailAddress
          }
        );
        if (isPartner) {
          this.changeCoverageFeatureFacade.sendAnalytics({
            event: FEATURES.CHANGE,
            pageAnalyticName: 'Complete'
          });
        } else {
          this.changeCoverageFeatureFacade.sendAnalytics({
            event: FEATURES.CHANGE,
            pageAnalyticName: 'Quote:Complete'
          });
        }
        this.confirmationData = this.formatConfirmationData(isPartner);
      });
  }
  backtoOverview() {
    if (!this.isPartner) {
      this.changeCoverageFeatureFacade.sendAnalytics({
        buttonAnalyticName: 'Quote:Complete:Overview',
        event: FEATURES.CHANGE
      });
    }
    this.store.dispatch(
      fromRouterActions.Go({
        path: ['/overview']
      })
    );
  }
  private formatConfirmationData(isPartner: boolean): ConfirmationModel {
    return {
      confirmation: {
        heading: this.copyService.getCopy(
          isPartner
            ? 'policy.changeCoverage.policyConfirmationHeading'
            : 'policy.changeCoverage.policyConfirmationHeadingAFI'
        ),
        status: 'success'
      }
    };
  }
}
